<div class="meeting-signature-container">
  <h2>{{ title }}</h2>

  <div class="signature-status">
    <p>{{ 'meeting.signature.collection.signature_status' | translate }}: <strong>{{ signedCount }}/{{ totalCount }}</strong></p>
  </div>

  <!-- 新增參與者表單 -->
  <div class="add-participant-form">
    <h3>{{ 'meeting.signature.collection.add_participant' | translate }}</h3>
    <div class="form-group">
      <label for="participantName">{{ 'meeting.signature.collection.name' | translate }}: <span class="required">*</span></label>
      <input
        type="text"
        id="participantName"
        [(ngModel)]="newParticipant.name"
        required
        [placeholder]="'meeting.signature.collection.name_placeholder' | translate"
      />
    </div>

    <div class="form-group">
      <label for="participantTitle">{{ 'meeting.signature.collection.title' | translate }}:</label>
      <input
        type="text"
        id="participantTitle"
        [(ngModel)]="newParticipant.title"
        [placeholder]="'meeting.signature.collection.title_placeholder' | translate"
      />
    </div>

    <div class="form-group">
      <label for="participantDepartment">{{ 'meeting.signature.collection.department' | translate }}:</label>
      <input
        type="text"
        id="participantDepartment"
        [(ngModel)]="newParticipant.department"
        [placeholder]="'meeting.signature.collection.department_placeholder' | translate"
      />
    </div>

    <button
      type="button"
      class="btn-add"
      (click)="addParticipant()"
    >
      {{ 'meeting.signature.collection.add_participant_button' | translate }}
    </button>
  </div>

  <!-- 參與者簽名列表 -->
  <div class="participants-list">
    <div *ngFor="let participant of participants" class="participant-item">
      <div class="participant-info">
        <h4>{{ participant.name }}</h4>
        <p *ngIf="participant.title || participant.department">
          <span *ngIf="participant.title">{{ participant.title }}</span>
          <span *ngIf="participant.department"> [{{ participant.department }}]</span>
        </p>
        <p *ngIf="participant.signedAt">
          {{ 'meeting.signature.collection.signed_time' | translate }}: {{ participant.signedAt | date:'yyyy-MM-dd HH:mm:ss' }}
        </p>
      </div>

      <div class="signature-area">
        <app-form-signature
          [id]="'signature_' + participant.id"
          [name]="'participant_signature_' + participant.id"
          [label]="'meeting.signature.collection.signature' | translate"
          [width]="300"
          [height]="120"
          [completeButtonText]="'meeting.signature.collection.complete_signature' | translate"
          [clearButtonText]="'meeting.signature.collection.clear_signature' | translate"
          (ngModelChange)="onSignatureChange($event, participant.id)"
          [ngModel]="participant.signature"
        ></app-form-signature>
      </div>

      <button
        type="button"
        class="btn-remove"
        (click)="removeParticipant(participant.id)"
        [title]="'meeting.signature.collection.remove_participant' | translate"
      >
        ✕
      </button>
    </div>

    <div *ngIf="participants.length === 0" class="no-participants">
      <p>{{ 'meeting.signature.collection.no_participants' | translate }}</p>
    </div>
  </div>
</div>
